var _desc, _defs, _rect, _path, _circle, _circle2, _circle3, _rect2, _rect3, _path2, _path3, _rect4, _circle4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "SPV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Pictogram\u0103 vectorial\u0103 pentru portal fiscal securizat, cu fereastr\u0103 web, scut \u0219i lac\u0103t.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purple",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7B248F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E1767"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 74,
    width: 376,
    height: 330,
    rx: 34,
    fill: "none",
    stroke: "url(#dark)",
    strokeWidth: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 74H396C415 74 430 89 430 108V166H54V108C54 89 69 74 88 74Z",
    fill: "url(#dark)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 120,
    r: 12,
    fill: "#F3F4F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 120,
    r: 12,
    fill: "#F3F4F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 120,
    r: 12,
    fill: "#F3F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 220,
    width: 220,
    height: 24,
    rx: 12,
    fill: "url(#dark)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 282,
    width: 160,
    height: 24,
    rx: 12,
    fill: "url(#dark)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386 188L476 221V316C476 384 437 433 386 462C335 433 296 384 296 316V221Z",
    fill: "url(#purple)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353 313V286C353 246 419 246 419 286V313",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 304,
    width: 96,
    height: 92,
    rx: 14,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 345,
    r: 12,
    fill: "#5B1B72"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 345,
    width: 12,
    height: 26,
    rx: 6,
    fill: "#5B1B72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpv);
export default __webpack_public_path__ + "static/media/spv.f522f35b8a2e23d3d027ab4e31d21032.svg";
export { ForwardRef as ReactComponent };